import { Hero } from "../sections/Hero";
import { Marquee } from "../components/Marquee";
import { WhyBasah } from "../sections/WhyBasah";
import { MenuPreview } from "../sections/MenuPreview";
import { SambalDuel } from "../sections/SambalDuel";
import { LocationsPreview } from "../sections/LocationsPreview";
import { PressBuzz } from "../sections/PressBuzz";
import { CtaBanner } from "../sections/CtaBanner";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <WhyBasah />
      <MenuPreview />
      <SambalDuel />
      <LocationsPreview />
      <PressBuzz />
      <CtaBanner />
    </div>
  );
}
